// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__i1gG9","content":"styles_content__2HoPp","icon":"styles_icon__n0zv7"};